import { useEffect, useState } from "react";
import { Box, Stack, useTheme } from "@mui/system";
import { IconButton, Modal, Slide, Typography } from "@mui/material";
import { toLocaleDateTimeString, formatSize } from "@utils";
import { Close as CloseIcon } from "@mui/icons-material";
import Scorecard from "@components/Scorecard";
import { ScorecardObject } from "@providers/hop-ord-server/api";
import {
  CompletedScorecard,
  PendingScorecard,
} from "@utils/useManageAttachments";

export const ScorecardPreviewModal = ({
  attachment,
  onClose,
}: {
  attachment: PendingScorecard | CompletedScorecard;
  onClose: () => void;
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewScorecard, setPreviewScorecard] =
    useState<ScorecardObject | null>(null);
  const theme = useTheme();

  useEffect(() => {
    setPreviewScorecard(attachment.scorecard);
    setPreviewOpen(true);
  }, [attachment]);

  const handleClose = () => {
    setPreviewOpen(false);
    onClose();
  };

  const createdAtText =
    attachment.state === "completed" &&
    `Sent: ${toLocaleDateTimeString(attachment.createdAt)}`;

  const infoText = [formatSize(attachment.size || 0), createdAtText]
    .filter(Boolean)
    .join(" • ");

  return (
    <Modal open={previewOpen} onClose={handleClose}>
      <Slide in={previewOpen} direction="up">
        <Stack
          sx={{
            padding: 2,
            height: 1,
            bgcolor: theme.palette.grey[900],
          }}
        >
          <Stack
            direction="row"
            sx={{
              color: "white",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Stack>
              <Typography>{attachment.name}</Typography>
              <Typography>{infoText}</Typography>
            </Stack>
            <IconButton onClick={handleClose} color="inherit">
              <CloseIcon />
            </IconButton>
          </Stack>
          <Stack
            sx={{
              overflow: "auto",
              justifyContent: "center",
              alignItems: "center",
              height: 1,
            }}
          >
            <Box sx={{ overflow: "auto", width: { xs: "80%", lg: "50%" } }}>
              {previewScorecard && <Scorecard data={previewScorecard} />}
            </Box>
          </Stack>
        </Stack>
      </Slide>
    </Modal>
  );
};
